import styled from 'styled-components'

const BlogPostCategoriesUiNew = styled.a`
  text-decoration: none;
  transition: all 0.3s ease-in-out 0s;
  margin-right: 5px;
`

export default BlogPostCategoriesUiNew
